import styled from 'styled-components';

const Span = styled.span`
  box-sizing: border-box;
  display: flex;
  height: 100%;
  padding: 0.8em 0.8em 0.8em 0em;
  align-items: center;
  justify-content: center;
`;

export default Span;



// WEBPACK FOOTER //
// ./src/components/Readings/styled/Span.js